import { Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import * as SX from './sx';
import type { TestimonialCardYoutubeProps as Props } from './types';

export const TestimonialCardYoutube = memo(
  ({ testimonial, onSelect, className }: Props) => {
    const { videoId, channel, title } = testimonial;
    const thumbUrl = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

    const handleClick = useCallback(() => {
      onSelect(testimonial);
    }, [onSelect, testimonial]);

    return (
      <Box
        component="button"
        type="button"
        onClick={handleClick}
        className={classnames('TestimonialCardYoutube', className)}
        sx={SX.root}
      >
        <Box
          sx={{
            ...SX.thumbnail,
            backgroundImage: `url(${thumbUrl})`,
          }}
        >
          <Box sx={SX.sourceBadge}>
            <Label color="error" variant="soft" size="xsmall">
              YouTube
            </Label>
          </Box>
        </Box>

        <Box sx={SX.body}>
          <Typography
            variant="body2"
            color="grey.700"
            fontWeight={700}
            mb={1}
            sx={SX.titleClamp}
          >
            {title}
          </Typography>
          <Box sx={SX.footerRow}>
            <Typography
              variant="body3"
              fontWeight={400}
              color="grey.700"
              noWrap
            >
              @{channel}
            </Typography>
            <Button variant="soft" color="default" size="xsmall">
              Watch Video
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }
);

TestimonialCardYoutube.displayName = 'TestimonialCardYoutube';
